<template>
  <div class="drag-drop">
      <div v-if="this.dragActive"
      ref="dropzone"
      @dragleave="dragleave"
      @drop="drop"
      class="dropzone-container"
           :class="{'dropzone-call': this.call}">
          <input
          type="file"
          multiple
          name="file"
          id="fileInput"
          class="hidden-input"
          @change="onChange"
          ref="file"
          accept=".pdf,.jpg,.jpeg,.png,.txt"/>
          <label for="fileInput" aria-live="assertive" class="file-label">
            <div v-if="!isMobile()" class="main-text-container">
              <span class="main-text">{{ $gettext('Arrastra y suelta archivos aquí.') }}</span>
              <div class="tooltip-info">
                {{ $gettext('O') }}
                <label
                  for="fileInput"
                  tabindex="0"
                  role="button"
                  @keydown.enter.prevent="$refs.file.click()"
                  @keydown.space.prevent="$refs.file.click()"
                >
                  <span class="secondary-text clickable">{{ $gettext('busca archivos') }}</span>
                </label>
                <span style="font-weight: 100;">(máx. 5mb)</span>
                <span class="icon-info"
                   :title="$gettext('Tipos de archivos permitidos: jpg, png, jpeg, pdf y txt.')"></span>
              </div>
            </div>

            <div v-else>
              <span class="main-text" tabindex="0">{{$gettext('Pulsa aqui para añadir archivos')}}</span>
            </div>

          </label>
          <div class="drop-files-container">
              <div class="preview-container" v-if="files.length">
                  <div v-for="(file, index) in files" :key="file.name" class="preview-card">
                      <div class="img-container">
                          <input type="checkbox" tabindex="0" class="delete-img" @click="selectImageToDelete(file)" :checked="selectedFiles.includes(file)">
                          <img v-if="file.type == 'application/pdf'" src="../assets/images/pdfico.png">
                          <img class="preview-img" v-else :src="generateThumbnail(file)" />
                      </div>
                      <div class="card-footer">
                        <p :title="file.name" tabindex="0" class="preview-text-img">{{ makeName(file.name) }}</p>
<!--                          <p  class="preview-text-size">{{ file.size }}</p>-->
                      </div>
                  </div>
              </div>
              <div class="empty-preview-container" v-else-if="!files.length && !isMobile()"  >
                <span>Drop your files here</span>
              </div>
          </div>
          <div class="file-footer-buttons">
            <button 
                @click="close" 
                tabindex="0" 
                class="close-drag"
                name="closeDrag">{{$gettext('Cancelar')}}</button>
            <button 
                @click="deleteSelectedFiles" 
                tabindex="0" 
                v-if="selectedFiles.length" 
                class="delete-selected"
                name="deleteSelectedFiles"
                >
              <div class="thrash-icon"></div>{{$gettext('Eliminar archivos')}}</button>
            <button 
                @click="uploadFiles" 
                tabindex="0" 
                :class="{'disabled' : files.length == 0}" 
                :disabled="files.length == 0" 
                v-else 
                class="sendButton"
                name="sendFiles">{{$gettext('Enviar archivos')}}</button>
          </div>
      </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';


export default {
  data() {
    return {
      files: [],
      selectedFiles: [],
      allowedTypes: ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png', 'text/plain'],
    };
  },
  methods: {
    ...mapActions(['sendUserFiles']),
    ...mapMutations(['updateDrag']),
    onChange(e){
      e.preventDefault();
      this.checkfile(e.target.files);
    },
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },

    generateThumbnail(file) {
      let fileSrc = URL.createObjectURL(file);
      setTimeout(() => {
        URL.revokeObjectURL(fileSrc);
      }, 1000);
      return fileSrc;
    },

    makeName(name) {
      if (name.split(".")[0].length > 7) {
        return (
            name.split(".")[0].substring(0, 7) + "..." + name.slice(-3)
        );
      } else {
        return name;
      }
    },

    remove(i) {
      this.files.splice(i, 1);
    },

    dragleave() {
      if(this.files.length >= 1){
          this.updateDrag(true);
      }else{
          this.updateDrag(false);
      }
    },
    close(){
      this.updateDrag(false);
    },
    drop(e) {
      e.preventDefault();
      this.checkfile(e.dataTransfer.files);
    },
    checkfile(files){
      for (const file of files) {
        if (file.size > 5000000) {
          alert(this.$gettextInterpolate(this.$gettext('No se puede cargar el archivo \'%{ fileName }\', su tamaño supera el límite de 5mb'), { fileName: file.name }))
        } else if(!this.allowedTypes.includes(file.type)){
          alert(this.$gettextInterpolate(this.$gettext('No se puede cargar el archivo \'%{ fileName }\', formato no permitido'), { fileName: file.name }))
        }else{
          if(this.files.length < 5 ){
            this.files.push(file);
          }else{
            if (this.files.length < 5) {
                this.files.push(file);
              } else {alert(this.$gettext('Máximo de 5 archivos pueden ser subidos'));
            }
          }
        }
      }
    },
    uploadFiles() {
      this.sendUserFiles(this.files);
      this.updateDrag(false);
      this.files = [];
    },
    selectImageToDelete(file){
      const index = this.selectedFiles.indexOf(file);
      if (index > -1) {
        // Si el archivo ya está seleccionado, lo eliminamos del array
        this.selectedFiles.splice(index, 1);
      } else {
        // Si el archivo no está seleccionado, lo agregamos
        this.selectedFiles.push(file);
      }
    },

    deleteSelectedFiles() {
      // Filtramos los archivos que no están seleccionados
      this.files = this.files.filter(file => !this.selectedFiles.includes(file));
      // Limpiamos el array de archivos seleccionados
      this.selectedFiles = [];
    }
  },
  watch: {
    dragActive(value){
      if(value == false){
        this.files = [];
      }
    }
  },
  computed:{
    ...mapState(['dragActive', 'call']),
  }
};
</script>